import {gql} from "@apollo/client";
import {AnonymousResult} from "../../schema";
import AnonymousSessionsTable from "../../components/account/anonymous-sessions-table/AnonymousSessionsTable";

export type QueryData = {
  paginatedList: {
    items: AnonymousResult[];
    countItems: number;
  }
}

export const anonymousSessionsQuery = gql`
  query GetAnonymousSessionsQuery($limit: Int!, $offset: Int) {
    paginatedList: getAnonymousSessions(first: $limit, skip: $offset) {
      items {
        ...AnonymousSessions
      }
      countItems
    }
  }
  ${AnonymousSessionsTable.fragments.anonymousSessions}
`;
